import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse,} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {tap, timeout} from "rxjs/operators";
import {UserService} from "../services/user.service";
import {AppService} from "../services/app.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    HTTP_RESPONSE = environment.HTTP_RESPONSE;
    constructor(
        private app: AppService,
        private user: UserService
    ) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const authToken = this.app.user.userToken;
        if (authToken) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Token token="${authToken}"`,
                },
            });
        }
        return next.handle(request).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    event = event.clone({body: this.redireccionarSegunRespuesta(event.body)});
                }
                return event;
                // Cancela la peticion al navegar entre routers
            }),
            //Cancelo la peticion si pasa los 30 seg
            timeout(600000)
        );
    }

    private async redireccionarSegunRespuesta(body: any) {
        if (Number(body.tipo) === Number(this.HTTP_RESPONSE.PERMISION_ERROR)) {
            this.user.logout();
        }
    }

}
